import { closePal } from './chat';
import { onEscape } from './esc';
import { VIEW } from '../../../3-store/meeting/chat';
import { IMG_RE } from '../../../../shared/limits';

// 사진 뷰어: 휠·핀치 확대, 끌어서 이동, 더블 클릭·탭 1x/2x, 바깥 클릭·닫기 단추·Esc 닫기, 저장 링크. v2에서 옮겼다. 모양은 index.html (#view).
const G = (window as any).G;
const $ = (id: string) => document.getElementById(id) as HTMLElement;
const clamp = (v: number, a: number, b: number) => Math.max(a, Math.min(b, v));
let vw: HTMLElement, vi: HTMLImageElement, vs: HTMLAnchorElement;
const vp = new Map<number, { x: number; y: number; x0: number; y0: number; mv: boolean; solo: boolean }>();
let vTap = { t: 0, x: 0, y: 0 }, vPinch = { d: 1, z: 1 };
function viewPaint() { const mx = (VIEW.z - 1) * innerWidth / 2, my = (VIEW.z - 1) * innerHeight / 2; VIEW.x = clamp(VIEW.x, -mx, mx); VIEW.y = clamp(VIEW.y, -my, my); vi.style.transform = `translate(${VIEW.x}px,${VIEW.y}px) scale(${VIEW.z})`; }
function viewZoom(z: number, px: number, py: number) {   // 화면 점 (px,py)가 제자리에 있도록 z배로
  z = clamp(z, 1, 8); const k = z / VIEW.z, cx = innerWidth / 2, cy = innerHeight / 2;
  VIEW.x = px - cx - k * (px - cx - VIEW.x); VIEW.y = py - cy - k * (py - cy - VIEW.y); VIEW.z = z; viewPaint();
}
export function openView(data: string) {
  if (!IMG_RE.test(data)) return;
  closePal(); (document.activeElement as HTMLElement | null)?.blur?.(); vp.clear(); vi.src = data; vs.href = data; Object.assign(VIEW, { open: true, z: 1, x: 0, y: 0 }); viewPaint(); vw.hidden = false; G.input.locked = true;
}
export function closeView() { if (!VIEW.open) return; VIEW.open = false; vw.hidden = true; vi.removeAttribute('src'); vs.removeAttribute('href'); vp.clear(); G.input.locked = false; }
function inPhoto(x: number, y: number) {   // object-fit:contain으로 실제 그려진 사진 영역 안인가 (바깥 = 배경)
  const r = vi.getBoundingClientRect(), nr = vi.naturalWidth / vi.naturalHeight || 1, w = Math.min(r.width, r.height * nr), h = w / nr;
  return Math.abs(x - r.left - r.width / 2) <= w / 2 && Math.abs(y - r.top - r.height / 2) <= h / 2;
}
const viewUp = (e: PointerEvent) => {
  const p = vp.get(e.pointerId); if (!p) return; vp.delete(e.pointerId);
  if (e.type !== 'pointerup' || p.mv || !p.solo) return;   // 끌었거나 두 손가락이었으면 탭이 아니다
  const now = performance.now();
  if (now - vTap.t < 320 && Math.hypot(e.clientX - vTap.x, e.clientY - vTap.y) < 30) { vTap.t = 0; viewZoom(VIEW.z > 1 ? 1 : 2, e.clientX, e.clientY); return; }   // 더블 클릭·탭
  vTap = { t: now, x: e.clientX, y: e.clientY };
  if (!inPhoto(e.clientX, e.clientY)) closeView();
};

export function initViewer() {
  vw = $('view'); vi = $('viewImg') as HTMLImageElement; vs = $('viewSave') as HTMLAnchorElement;
  onEscape({ isOpen: () => VIEW.open, close: closeView });
  $('viewX').onclick = closeView;
  vw.addEventListener('wheel', (e) => { e.preventDefault(); viewZoom(VIEW.z * Math.exp(-e.deltaY * 0.0015), e.clientX, e.clientY); }, { passive: false });
  vw.addEventListener('pointerdown', (e) => {
    if ((e.target as HTMLElement).closest('a,button') || (e.pointerType === 'mouse' && e.button !== 0)) return;
    vw.setPointerCapture(e.pointerId); vp.set(e.pointerId, { x: e.clientX, y: e.clientY, x0: e.clientX, y0: e.clientY, mv: false, solo: vp.size === 0 });
    if (vp.size === 2) { const [a, b] = [...vp.values()]; vPinch = { d: Math.hypot(a.x - b.x, a.y - b.y) || 1, z: VIEW.z }; }
  });
  vw.addEventListener('pointermove', (e) => {
    const p = vp.get(e.pointerId); if (!p) return;
    const dx = e.clientX - p.x, dy = e.clientY - p.y; p.x = e.clientX; p.y = e.clientY; if (Math.hypot(p.x - p.x0, p.y - p.y0) >= 8) p.mv = true;
    if (vp.size === 2) { const [a, b] = [...vp.values()]; viewZoom(vPinch.z * Math.hypot(a.x - b.x, a.y - b.y) / vPinch.d, (a.x + b.x) / 2, (a.y + b.y) / 2); VIEW.x += dx / 2; VIEW.y += dy / 2; viewPaint(); }
    else if (VIEW.z > 1) { VIEW.x += dx; VIEW.y += dy; viewPaint(); }
  });
  vw.addEventListener('pointerup', viewUp); vw.addEventListener('pointercancel', viewUp);
}
